<template>
  <iframe
    ref="metabase"
    :src="src"
    width="100%"
    height="100%"
    frameborder="0"
    allowtransparency
  ></iframe>
</template>

<script>
export default {
  name: 'MetabaseApplication',

  props: {
    projectId: {
      required: false
    }
  },

  data() {
    return {
      src: this.buildSrc()
    }
  },

  mounted() {
    window.addEventListener('message', e => {
      if (e.data.metabase) {
        if (e.data.metabase.type === 'location') {
          const { pathname, hash } = e.data.metabase.location
          window.history.pushState(
            null,
            '',
            this.buildRedirectUrl(pathname, hash)
          )
        }
      }
    })
  },

  methods: {
    buildRedirectUrl(pathname, hash) {
      let url

      if (this.projectId) {
        url = '/metabase/project?project_id=' + this.projectId + '&'
      } else {
        url = '/metabase?'
      }

      url += 'path=' + encodeURIComponent(pathname)

      if (hash) {
        url += '&hash=' + encodeURIComponent(hash)
      }

      return url
    },

    buildSrc() {
      let url = '/'
      if (this.$route.query.path) {
        url = this.$route.query.path
      }

      url += '?side_nav=true&top_nav=true&search=true&new_button=true'

      if (this.$route.query.hash) {
        url += this.$route.query.hash
      }

      let jwt = this.projectId
        ? window.xp.metabaseProjectToken
        : window.xp.metabaseToken

      return (
        window.xp.metabaseUrl +
        '/auth/sso?jwt=' +
        encodeURIComponent(jwt) +
        '&return_to=' +
        encodeURIComponent(url)
      )
    }
  },

  watch: {
    '$route.query.path': {
      handler: function(path) {
        if (this.$refs['metabase']) {
          this.$refs['metabase'].contentWindow.postMessage(
            {
              metabase: {
                type: 'location',
                location: path
              }
            },
            // FIXME SECURITY: use whitelisted origin instead of "*"
            '*'
          )
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/metabase/pages/MetabaseApplication.vue